// eslint-disable-next-line no-unused-vars
import modal from '../smartpak/modal';
import * as constants from './constants';
import promoStore from './promostore';

export function findPromoFromParams(location) {
    const promoKeys = [
        'promo', 'aap'
    ];

    const params = new URLSearchParams(location.search);

    if (matchesLegacy10OffStrings(location.href)) {
        return constants.TEN_OFF_PROMO;
    }

    const promo = params.get(promoKeys.find(key => params.has(key)));

    if (promo === constants.OLD_10OFF_PARAMETER_VALUE) {
        return constants.TEN_OFF_PROMO;
    }

    return promo;
}

export function savePromo(promo) {
    return new Promise(resolve => {
        let promos = promoStore.get();

        if (promos.includes(promo)) {
            resolve(false);
            return;
        }

        promos.push(promo);

        promoStore.set(promos);
        resolve(true);
    });
}

export default function savePromosFromParams() {
    const promo = findPromoFromParams(location);

    if (promo) {
        savePromo(promo).then(saved => {
            if (saved) {
                showConfirmationModal();
            }
        });
    }
}

function showConfirmationModal() {
    const $element = document.createElement('div');
    $element.innerHTML = 'Congrats your offer has been applied, see details in check out.';

    modal($element, {
        title: 'Thank You!'
    });
}

function matchesLegacy10OffStrings(string) {
    const legacyStringsToMatch = [
        'Prospect+Onboarding+-+1+-+Discount',
        'Prospect Onboarding - 1 - Discount'
    ].map(str => escapeForRegex((str)));

    return new RegExp(legacyStringsToMatch.join('|'), 'gi').test(decodeURIComponent(string));
}

function escapeForRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}